import { Action, creator } from 'src/config/rootAction';

import {
    ActivitiesDataArguments,
    ActivitiesSelectionDomain,
    ChangeActivitiesActionArguments,
    ChangeActivityDataActionArguments,
    LivingAccordingToValues,
    PlannedActivity,
} from '../models/weekThree';

export const CHANGE_LIVING_ACCORDING_TO_VALUES_FEELINGS =
    'CHANGE_LIVING_ACCORDING_TO_VALUES_FEELINGS';
export type ChangeLivingAccordingToValuesFeelingAction = Action<
    typeof CHANGE_LIVING_ACCORDING_TO_VALUES_FEELINGS,
    {
        field: string;
        value: string;
    }
>;
export const changeLivingAccordingToValuesFeelings = creator<
    ChangeLivingAccordingToValuesFeelingAction
>(CHANGE_LIVING_ACCORDING_TO_VALUES_FEELINGS);

export const SUBMIT_LIVING_VALUES_DATA_REQUESTED = 'SUBMIT_LIVING_VALUES_DATA_REQUESTED';
export type SubmitLivingValuesDataRequestAction = Action<
    typeof SUBMIT_LIVING_VALUES_DATA_REQUESTED,
    LivingAccordingToValues
>;
export const submitLivingValuesDataRequest = creator<SubmitLivingValuesDataRequestAction>(
    SUBMIT_LIVING_VALUES_DATA_REQUESTED,
);

export const SUBMIT_LIVING_VALUES_DATA_SUCCEEDED = 'SUBMIT_LIVING_VALUES_DATA_SUCCEEDED';
export type SubmitLivingValuesDataSuccessAction = Action<
    typeof SUBMIT_LIVING_VALUES_DATA_SUCCEEDED,
    LivingAccordingToValues
>;
export const submitLivingValuesDataSuccess = creator<SubmitLivingValuesDataSuccessAction>(
    SUBMIT_LIVING_VALUES_DATA_SUCCEEDED,
);

export const SUBMIT_LIVING_VALUES_DATA_FAILED = 'SUBMIT_LIVING_VALUES_DATA_FAILED';
export type SubmitLivingValuesDataFailAction = Action<
    typeof SUBMIT_LIVING_VALUES_DATA_FAILED,
    LivingAccordingToValues
>;
export const submitLivingValuesDataFail = creator<SubmitLivingValuesDataFailAction>(
    SUBMIT_LIVING_VALUES_DATA_FAILED,
);

export const CHANGE_ACTION_ACTIVITIES = 'CHANGE_ACTION_ACTIVITIES';
export type ChangeActivitiesAction = Action<
    typeof CHANGE_ACTION_ACTIVITIES,
    ChangeActivitiesActionArguments
>;
export const changeActionActivities = creator<ChangeActivitiesAction>(CHANGE_ACTION_ACTIVITIES);

export const SUBMIT_ACTIVITIES_DATA_REQUESTED = 'SUBMIT_ACTIVITIES_DATA_REQUESTED';
export type SubmitActivitiesDataRequestAction = Action<
    typeof SUBMIT_ACTIVITIES_DATA_REQUESTED,
    PlannedActivity[]
>;
export const submitActivitiesData = creator<SubmitActivitiesDataRequestAction>(
    SUBMIT_ACTIVITIES_DATA_REQUESTED,
);

export const SUBMIT_ACTIVITIES_DATA_SUCCEEDED = 'SUBMIT_ACTIVITIES_DATA_SUCCEEDED';
export type SubmitActivitiesDataSuccessAction = Action<typeof SUBMIT_ACTIVITIES_DATA_SUCCEEDED>;
export const submitActivitiesDataSuccess = creator<SubmitActivitiesDataSuccessAction>(
    SUBMIT_ACTIVITIES_DATA_SUCCEEDED,
);

export const SUBMIT_ACTIVITIES_DATA_FAILED = 'SUBMIT_ACTIVITIES_DATA_FAILED';
export type SubmitActivitiesDataFailAction = Action<typeof SUBMIT_ACTIVITIES_DATA_FAILED>;
export const submitActivitiesDataFail = creator<SubmitActivitiesDataFailAction>(
    SUBMIT_ACTIVITIES_DATA_FAILED,
);

export const FETCH_ACTIVITIES_DATA_REQUESTED = 'FETCH_ACTIVITIES_DATA_REQUESTED';
export type FetchActivitiesDataRequestAction = Action<typeof FETCH_ACTIVITIES_DATA_REQUESTED>;
export const fetchActivitiesDataRequest = creator<FetchActivitiesDataRequestAction>(
    FETCH_ACTIVITIES_DATA_REQUESTED,
);

export const FETCH_ACTIVITIES_DATA_SUCCEEDED = 'FETCH_ACTIVITIES_DATA_SUCCEEDED';
export type FetchActivitiesDataSuccessAction = Action<
    typeof FETCH_ACTIVITIES_DATA_SUCCEEDED,
    ActivitiesSelectionDomain[]
>;
export const fetchActivitiesDataSuccess = creator<FetchActivitiesDataSuccessAction>(
    FETCH_ACTIVITIES_DATA_SUCCEEDED,
);

export const FETCH_ACTIVITIES_DATA_FAILED = 'FETCH_ACTIVITIES_DATA_FAILED';
export type FetchActivitiesDataFailAction = Action<typeof FETCH_ACTIVITIES_DATA_FAILED>;
export const fetchActivitiesDataFail = creator<FetchActivitiesDataFailAction>(
    FETCH_ACTIVITIES_DATA_FAILED,
);

export const CHANGE_ACTIVITY_DATA = 'CHANGE_ACTIVITY_DATA';
export type ChangeActivityDataAction = Action<
    typeof CHANGE_ACTIVITY_DATA,
    ChangeActivityDataActionArguments
>;
export const changeActionActivityData = creator<ChangeActivityDataAction>(CHANGE_ACTIVITY_DATA);

export const FETCH_PLANNED_ACTIVITIES_REQUESTED = 'FETCH_PLANNED_ACTIVITIES_REQUESTED';
export type FetchPlannedActivitiesRequestAction = Action<typeof FETCH_PLANNED_ACTIVITIES_REQUESTED>;
export const fetchPlannedActivitiesRequest = creator<FetchPlannedActivitiesRequestAction>(
    FETCH_PLANNED_ACTIVITIES_REQUESTED,
);

export const FETCH_PLANNED_ACTIVITIES_SUCCEEDED = 'FETCH_PLANNED_ACTIVITIES_SUCCEEDED';
export type FetchPlannedActivitiesSuccessAction = Action<
    typeof FETCH_PLANNED_ACTIVITIES_SUCCEEDED,
    ActivitiesDataArguments[]
>;
export const fetchPlannedActivitiesSuccess = creator<FetchPlannedActivitiesSuccessAction>(
    FETCH_PLANNED_ACTIVITIES_SUCCEEDED,
);

export const FETCH_PLANNED_ACTIVITIES_FAILED = 'FETCH_PLANNED_ACTIVITIES_FAILED';
export type FetchPlannedActivitiesFailAction = Action<typeof FETCH_PLANNED_ACTIVITIES_FAILED>;
export const fetchPlannedActivitiesFail = creator<FetchPlannedActivitiesFailAction>(
    FETCH_PLANNED_ACTIVITIES_FAILED,
);

export type WeekThreeAction =
    | ChangeLivingAccordingToValuesFeelingAction
    | SubmitLivingValuesDataRequestAction
    | SubmitLivingValuesDataSuccessAction
    | SubmitLivingValuesDataFailAction
    | ChangeActivitiesAction
    | SubmitActivitiesDataRequestAction
    | SubmitActivitiesDataSuccessAction
    | SubmitActivitiesDataFailAction
    | FetchActivitiesDataRequestAction
    | FetchActivitiesDataSuccessAction
    | FetchActivitiesDataFailAction
    | ChangeActivityDataAction
    | FetchPlannedActivitiesRequestAction
    | FetchPlannedActivitiesSuccessAction
    | FetchPlannedActivitiesFailAction;
